import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";

import { ResponsiveHeatMap } from '@nivo/heatmap'
import { scaleLinear } from 'd3-scale'

import CardHeader from "../Layout/CardHeader";
import SuperInsightsModal from "../Ia/SuperInsightsModal";
import Meta from '../Layout/Meta';

const colorScaleFutura = scaleLinear()  
  .domain([1, 3])  
  .range(['#FFE5CC', '#F7981D'])
  .clamp(true)

const colorScalePrevista = scaleLinear()
  .domain([1, 3])
  .range(['#DFF6E9', '#00AE5D'])
  .clamp(true)

const colorScaleAtual = scaleLinear()
  .domain([1, 3])
  .range(['#FFDFDF', '#D62D2D'])
  .clamp(true)

const HeatMap = ({ item }) => {

  const safeItem = item || {};
  const {
    Sigla = '',
    Descricao_Dashboard_Componente: titulo = "-",
    dadosComponente = {},
    Valor_Meta = {},
    Texto_Info = "-",
    Texto_BizAI = "",
    ESG_Info = "-",
    Codigo_Transacao_Link = "",
    Titulo_Transacao_Link = "",
    opcoesComponente,
  } = safeItem;

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const togglePopup = () => setIsPopupOpen(!isPopupOpen);  
  const slugId = Sigla.trim().replace(/\s+/g, "-");
  
  return (
     <>
    <Card className="w-100 h-100 ">
      <CardBody className="w-100 h-100 d-flex flex-column cardbody-dash">
        <CardHeader
            titulo={titulo}
            Texto_Info={Texto_Info}
            ESG_Info={ESG_Info}
            togglePopup={togglePopup}
            slugId={slugId}
            textoIA={Texto_BizAI}
            Codigo_Transacao_Link={Codigo_Transacao_Link}
            Titulo_Transacao_Link={Titulo_Transacao_Link}
        />   
        <Meta Valor_Meta={Valor_Meta} />

         <div style={{ marginTop: "20px", width: "100%", height: "300px" }}>
          <ResponsiveHeatMap
            data={dadosComponente}
            forceSquare={false}
            padding={6}
            borderWidth={10}
            borderColor="#ffffff"

            colors={(cell) => {
              if (cell.serieId === 'Futura') {
                return colorScaleFutura(cell.data.y)
              } else if (cell.serieId === 'Prevista') {
                return colorScalePrevista(cell.data.y)
              } else if (cell.serieId === 'Atual') {
                return colorScaleAtual(cell.data.y)
              }
              return '#cccccc'
            }}
            hoverTarget="column"
            cellHoverOthersOpacity={0.25}
            margin={{ top: 30, right: 60, bottom: 70, left: 60 }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: -90,
            }}
            axisLeft={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
            }}
          />
        </div>

      </CardBody>
    </Card>

    <SuperInsightsModal
        isOpen={isPopupOpen}
        toggle={togglePopup}
        textoIA={Texto_BizAI} 
      />
    </>
  );
};

export default HeatMap;
